// extracted by mini-css-extract-plugin
export default {"container":"toggleSwitch_container__HHoPG","switch":"toggleSwitch_switch__OnQmL","slider":"toggleSwitch_slider__tUYuO"};